export const DJANGO_ADMIN_URL =
  process.env.NEXT_PUBLIC_DJANGO_ADMIN_URL || `/headquarters/`;

export const SYSTEM_DEFAULT_TZ = 'Europe/Berlin';

export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
